type InputProps = {
  value: string | number
  placeholder: string
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  className?: React.ComponentProps<'div'>['className']
  length?: number
  autoFocus?: boolean
  mode?: React.HTMLAttributes<HTMLInputElement>['inputMode']
}

const Input = ({ value, placeholder, onChange, className, length, autoFocus, mode }: InputProps) => {
  return (
    <input
      className={`${className ? className : ''} h-[30px] w-full rounded-none bg-gray-010 text-text-090`}
      value={value}
      placeholder={placeholder}
      onChange={onChange}
      autoFocus={autoFocus}
      maxLength={length}
      inputMode={mode}
    />
  )
}

export default Input
